import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid
} from '@material-ui/core';
import { withTheme } from '@material-ui/styles';
import FormikInput from '../atom/FormikInput';
import FormikPhoneInput from '../atom/FormikPhoneInput';
import { ErrorIcon } from '../../icons';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';
import { validatePhone } from '../../helpers/phoneUtils';

const validateAgentAddForm = values => {
    const errors = {};

    if (!values.firstname) {
        errors.firstname = 'First name is required.';
    }

    if (!values.lastname) {
        errors.lastname = 'Last name is required.';
    }

    const phoneError = validatePhone(values.phone);
    if (phoneError) {
        errors.phone = phoneError;
    }

    if (!values.email) {
        errors.email = 'Email is required.';
    }

    if (!values.password) {
        errors.password = 'Password is required.';
    }

    if (!values.passwordCeck) {
        errors.passwordCheck = 'Password confirmation is required.';
    }

    if (values.password && values.passwordCheck) {
        delete errors.password;
        delete errors.passwordCheck;
        if (values.password !== values.passwordCheck) {
            errors.passwordCheck = "Passwords don't match";
        }
    }
    return errors;
};

const AddAgentModal = ({ theme, showModal, MODAL_TYPE, clientId }) => {
    const [success, setSuccess] = useState(false);
    const onClose = () => showModal(MODAL_TYPE.NONE);

    const onFormSubmit = async (agentData, setters) => {
        try {
            const postData = { ...agentData };
            delete postData.passwordCheck;
            await doSwaggerCall('users', 'createUser', {
                user: {
                    ...postData,
                    client_id: parseInt(clientId, 10),
                    send_welcome_email: true,
                    sentRole: 'agent'
                }
            });
            setSuccess(true);
        } catch (err) {
            setters.setErrors({
                api: `${agentData.email} - ${err?.response?.body?.message || err.toString()}`
            });
        }
    };

    return (
        <Dialog
            aria-labelledby="agent-manual-add-modal"
            open
            onClose={() => showModal(MODAL_TYPE.NONE)}
        >
            <DialogTitle>Add new agent</DialogTitle>
            <Formik
                validate={validateAgentAddForm}
                initialValues={{
                    firstname: '',
                    lastname: '',
                    phone: '',
                    email: '',
                    password: '',
                    passwordCheck: ''
                }}
                onSubmit={(values, { setSubmitting, setErrors }) =>
                    onFormSubmit(values, { setSubmitting, setErrors })
                }
            >
                {({ isSubmitting, errors, isValid, dirty }) => (
                    <Form>
                        <DialogContent>
                            <Grid container spacing={2}>
                                {errors?.api && (
                                    <Grid
                                        item
                                        container
                                        spacing={2}
                                        xs={12}
                                        style={{
                                            color: theme.palette.error.main
                                        }}
                                        alignItems="center"
                                    >
                                        <Grid item>
                                            <ErrorIcon color="error" />
                                        </Grid>
                                        <Grid item>
                                            <span>{errors?.api}</span>
                                        </Grid>
                                    </Grid>
                                )}
                                {success && (
                                    <Grid
                                        item
                                        container
                                        xs={12}
                                        style={{
                                            color: theme.palette.success.main
                                        }}
                                        alignItems="center"
                                    >
                                        <Grid item>
                                            <span>Agent successfully added to client.</span>
                                        </Grid>
                                    </Grid>
                                )}
                                {!success && (
                                    <>
                                        <FormikInput
                                            label="First name"
                                            required
                                            type="text"
                                            name="firstname"
                                        />
                                        <FormikInput
                                            label="Last name"
                                            required
                                            type="text"
                                            name="lastname"
                                        />
                                        <FormikPhoneInput label="Phone" required name="phone" />
                                        <FormikInput
                                            label="Email"
                                            required
                                            type="email"
                                            name="email"
                                        />
                                        <FormikInput
                                            label="Password"
                                            required
                                            type="password"
                                            name="password"
                                        />
                                        <FormikInput
                                            label="Confirm password"
                                            required
                                            type="password"
                                            name="passwordCheck"
                                        />
                                    </>
                                )}
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            {isSubmitting && <CircularProgress />}
                            <Button variant="contained" onClick={onClose}>
                                Close
                            </Button>
                            {!success && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    disabled={isSubmitting || !(isValid && dirty)}
                                >
                                    Save agent
                                </Button>
                            )}
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default withTheme(AddAgentModal);
